import React, { useState } from "react";

export default function Contact() {
  const [form, setForm]     = useState({ name:"", email:"", phone:"", subject:"", message:"" });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setStatus("sending");

    // ✏️ Replace with your real email API (EmailJS, Resend, Formspree etc.)
    // For now we simulate a successful send after 1.5s
    await new Promise(r => setTimeout(r, 1500));

    // Example with Formspree (free):
    // const res = await fetch("https://formspree.io/f/YOUR_FORM_ID", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(form)
    // });
    // if (res.ok) setStatus("success"); else setStatus("error");

    setStatus("success");
    setForm({ name:"", email:"", phone:"", subject:"", message:"" });
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=DM+Sans:wght@300;400;500&display=swap');
        .ct-root*,.ct-root *::before,.ct-root *::after{box-sizing:border-box;margin:0;padding:0}
        .ct-root{font-family:'DM Sans',sans-serif;background:#fdf9f6;min-height:80vh}

        /* HERO */
        .ct-hero{
          background:#1a1410;
          padding:64px 40px 52px;
          text-align:center;
          position:relative;
          overflow:hidden;
        }
        .ct-hero::before{
          content:'HELLO';
          position:absolute;
          top:50%;left:50%;
          transform:translate(-50%,-50%);
          font-family:'Cormorant Garamond',serif;
          font-size:clamp(60px,14vw,180px);
          font-weight:300;
          color:transparent;
          -webkit-text-stroke:1px rgba(200,112,144,0.1);
          white-space:nowrap;
          pointer-events:none;
        }
        .ct-eyebrow{
          font-size:10px;font-weight:500;letter-spacing:.28em;
          text-transform:uppercase;color:#c87090;
          margin-bottom:14px;display:block;position:relative;z-index:1;
        }
        .ct-hero-title{
          font-family:'Cormorant Garamond',serif;
          font-size:clamp(36px,6vw,62px);
          font-weight:300;color:#fdf9f6;
          display:block;position:relative;z-index:1;
          margin-bottom:12px;letter-spacing:-.01em;
        }
        .ct-hero-sub{
          font-size:14px;font-weight:300;
          color:rgba(253,249,246,0.55);
          display:block;position:relative;z-index:1;
        }

        /* BODY */
        .ct-body{
          max-width:1100px;
          margin:0 auto;
          padding:60px 40px 80px;
          display:grid;
          grid-template-columns:1fr 1.6fr;
          gap:64px;
          align-items:start;
        }
        @media(max-width:860px){
          .ct-body{grid-template-columns:1fr;gap:40px;padding:40px 20px 60px}
        }

        /* INFO SIDE */
        .ct-info-title{
          font-family:'Cormorant Garamond',serif;
          font-size:30px;font-weight:300;color:#1a1410;
          margin-bottom:8px;display:block;letter-spacing:-.01em;
        }
        .ct-info-sub{
          font-size:14px;font-weight:300;color:#7a6e68;
          line-height:1.7;margin-bottom:36px;display:block;
        }
        .ct-info-cards{display:flex;flex-direction:column;gap:16px}
        .ct-info-card{
          background:#fff;
          border:1px solid #ede8e2;
          padding:18px 20px;
          display:flex;
          align-items:flex-start;
          gap:14px;
        }
        .ct-info-icon{
          width:38px;height:38px;
          background:#fff5f8;
          border:1px solid #f5d0dc;
          border-radius:50%;
          display:flex;align-items:center;justify-content:center;
          flex-shrink:0;
        }
        .ct-info-label{
          font-size:10px;font-weight:500;letter-spacing:.18em;
          text-transform:uppercase;color:#c87090;
          margin-bottom:4px;display:block;
        }
        .ct-info-val{
          font-size:13.5px;font-weight:400;color:#1a1410;
          display:block;line-height:1.5;
        }
        .ct-info-hint{
          font-size:11.5px;font-weight:300;color:#a09890;
          display:block;margin-top:2px;
        }

        /* FORM */
        .ct-form-wrap{
          background:#fff;
          border:1px solid #ede8e2;
          padding:36px;
        }
        @media(max-width:480px){.ct-form-wrap{padding:24px 20px}}
        .ct-form-title{
          font-family:'Cormorant Garamond',serif;
          font-size:24px;font-weight:400;color:#1a1410;
          margin-bottom:24px;display:block;
        }
        .ct-form{display:flex;flex-direction:column;gap:16px}
        .ct-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}
        @media(max-width:480px){.ct-row{grid-template-columns:1fr}}
        .ct-field{display:flex;flex-direction:column;gap:6px}
        .ct-label{
          font-size:10.5px;font-weight:500;letter-spacing:.16em;
          text-transform:uppercase;color:#7a6e68;
        }
        .ct-input{
          border:1.5px solid #ddd8d2;
          background:#fdf9f6;
          padding:10px 12px;
          font-size:13.5px;
          font-family:'DM Sans',sans-serif;
          color:#1a1410;
          outline:none;
          transition:border-color .18s;
          width:100%;
        }
        .ct-input:focus{border-color:#c87090;background:#fff}
        .ct-textarea{resize:vertical;min-height:120px}
        .ct-submit{
          padding:14px;
          background:#1a1410;
          color:#fdf9f6;
          border:none;
          font-size:11px;
          font-weight:500;
          font-family:'DM Sans',sans-serif;
          letter-spacing:.18em;
          text-transform:uppercase;
          cursor:pointer;
          transition:background .22s;
          margin-top:4px;
        }
        .ct-submit:hover{background:#c87090}
        .ct-submit:disabled{opacity:.55;cursor:not-allowed}
        .ct-submit.success{background:#c87090}
        .ct-success{
          background:#fff5f8;
          border:1px solid #f5d0dc;
          padding:16px 18px;
          font-size:13.5px;
          color:#c87090;
          text-align:center;
          margin-top:4px;
          display:block;
        }
        .ct-error-msg{
          font-size:12px;color:#c87090;font-style:italic;
        }

        /* DIVIDER */
        .ct-divider{
          height:1px;
          background:linear-gradient(to right,transparent,#ede8e2,transparent);
          margin:48px 0;
          max-width:1100px;
          margin-left:auto;margin-right:auto;
        }
        .ct-note{
          max-width:1100px;margin:0 auto;
          padding:0 40px 60px;
          text-align:center;
        }
        @media(max-width:768px){.ct-note{padding:0 20px 40px}}
        .ct-note-text{
          font-size:13px;font-weight:300;color:#a09890;
          line-height:1.7;display:block;
        }
      `}</style>

      <div className="ct-root">

        {/* HERO */}
        <div className="ct-hero">
          <span className="ct-eyebrow">Get in Touch</span>
          <span className="ct-hero-title">Contact Us</span>
          <span className="ct-hero-sub">We'd love to hear from you - reach out anytime</span>
        </div>

        {/* BODY */}
        <div className="ct-body">

          {/* INFO */}
          <div>
            <span className="ct-info-title">We're here to help</span>
            <span className="ct-info-sub">
              Questions about your order, sizing, or anything else?<br/>
              Our team is ready to assist.
            </span>

            <div className="ct-info-cards">
              <div className="ct-info-card">
                <div className="ct-info-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c87090" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.13 1.21 2 2 0 012.1 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/>
                  </svg>
                </div>
                <div>
                  <span className="ct-info-label">WhatsApp / Phone</span>
                  <span className="ct-info-val">+92 300 000 0000</span>
                  <span className="ct-info-hint">Mon – Sat, 10am – 8pm PKT</span>
                </div>
              </div>

              <div className="ct-info-card">
                <div className="ct-info-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c87090" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div>
                  <span className="ct-info-label">Email</span>
                  <span className="ct-info-val"> info@stmzgroup.com</span>
                  <span className="ct-info-hint">We reply within 24 hours</span>
                </div>
              </div>

              <div className="ct-info-card">
                <div className="ct-info-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c87090" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div>
                  <span className="ct-info-label">Location</span>
                  <span className="ct-info-val">Pakistan</span>
                  <span className="ct-info-hint">Nationwide delivery available</span>
                </div>
              </div>
            </div>
          </div>

          {/* FORM */}
          <div className="ct-form-wrap">
            <span className="ct-form-title">Send us a message</span>

            {status === "success" ? (
              <span className="ct-success">
                ✓ Message sent! We'll get back to you within 24 hours.
              </span>
            ) : (
              <form onSubmit={handleSubmit} className="ct-form">

                <div className="ct-row">
                  <div className="ct-field">
                    <label className="ct-label">Your Name *</label>
                    <input
                      name="name" value={form.name} onChange={handleChange}
                      className="ct-input" placeholder="e.g. Sara Khan" required
                    />
                  </div>
                  <div className="ct-field">
                    <label className="ct-label">Email *</label>
                    <input
                      name="email" type="email" value={form.email} onChange={handleChange}
                      className="ct-input" placeholder="you@email.com" required
                    />
                  </div>
                </div>

                <div className="ct-row">
                  <div className="ct-field">
                    <label className="ct-label">Phone</label>
                    <input
                      name="phone" value={form.phone} onChange={handleChange}
                      className="ct-input" placeholder="+92 3XX XXXXXXX"
                    />
                  </div>
                  <div className="ct-field">
                    <label className="ct-label">Subject</label>
                    <input
                      name="subject" value={form.subject} onChange={handleChange}
                      className="ct-input" placeholder="Order query, sizing, etc."
                    />
                  </div>
                </div>

                <div className="ct-field">
                  <label className="ct-label">Message *</label>
                  <textarea
                    name="message" value={form.message} onChange={handleChange}
                    className="ct-input ct-textarea" rows={5}
                    placeholder="Tell us how we can help you…" required
                  />
                </div>

                {status === "error" && (
                  <span className="ct-error-msg">Something went wrong. Please try again.</span>
                )}

                <button
                  type="submit"
                  disabled={status === "sending"}
                  className={`ct-submit ${status === "success" ? "success" : ""}`}
                >
                  {status === "sending" ? "Sending…" : "Send Message"}
                </button>

              </form>
            )}
          </div>

        </div>

        {/* BOTTOM NOTE */}
        <div className="ct-divider" />
        <div className="ct-note">
          <span className="ct-note-text">
            For order tracking, use the <a href="/track" style={{color:"#c87090",textDecoration:"none",borderBottom:"1px solid #c87090"}}>Track Order</a> page.
            For urgent queries, reach us on WhatsApp for the fastest response.
          </span>
        </div>

      </div>
    </>
  );
}